module.exports = __webpack_public_path__ + "img/undraw_Landscape_mode_re_r964.acba8605.svg";